import React, { useEffect } from 'react';

const PickingListModal = ({ show, onClose, data }) => {
  useEffect(() => {
    console.log('PickingListModal data:', data);
    console.log('Data length:', data?.length);
    console.log('First item:', data?.[0]);
  }, [data]);

  const copyToClipboard = () => {
    const text = data.map(item => `Pick ${item.quantityToPick}pcs from ${item.shelvingCode}: ${item.title}`).join('\n');
    navigator.clipboard.writeText(text).then(() => {
      alert('Picking list copied to clipboard!');
    }, () => {
      alert('Failed to copy picking list to clipboard.');
    });
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg overflow-hidden shadow-xl max-w-2xl w-full">
        <div className="p-4 border-b">
          <h2 className="text-lg font-semibold">Picking List {data?.length ? `(${data.length} items)` : '(Empty)'}</h2>
        </div>
        <div className="p-4 max-h-96 overflow-y-auto">
          {data && data.length > 0 ? (
            data.map((item, index) => (
              <div key={index} className="mb-2">
                <strong>Pick {item.quantityToPick}pcs from {item.shelvingCode}</strong>: {item.title}
              </div>
            ))
          ) : (
            <div className="text-center text-gray-500">No items to pick</div>
          )}
        </div>
        <div className="p-4 border-t flex justify-end space-x-2">
          <button
            className="bg-gray-500 text-white px-4 py-2 rounded"
            onClick={onClose}
          >
            Close
          </button>
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded"
            onClick={copyToClipboard}
            disabled={!data || data.length === 0}
          >
            Copy to Clipboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default PickingListModal;
